export default __webpack_public_path__ + "static/media/port.517e2750.jpg";